import type { SectionLocale } from '../types'

export const ADMIN_DEPARTMENTS_LOCALE: SectionLocale = [
  [
    'admin_departments_title',
    {
      ru: 'Департаменты',
      en: 'Departments',
    },
  ],
  [
    'admin_departments_add_department',
    {
      ru: 'Добавить департамент',
      en: 'Add department',
    },
  ],
  [
    'admin_departments_add_employee',
    {
      ru: 'Добавить сотрудника',
      en: 'Add employee',
    },
  ],
  [
    'admin_departments_no_data_available',
    {
      ru: 'Нет данных',
      en: 'No data available',
    },
  ],
  [
    'admin_departments_table_name',
    {
      ru: 'Название',
      en: 'Name',
    },
  ],
  [
    'admin_departments_table_id',
    {
      ru: 'ID',
      en: 'ID',
    },
  ],
  [
    'admin_departments_delete_department_question',
    {
      ru: 'Удалить папку департамента?',
      en: 'Delete department folder?',
    },
  ],
  [
    'admin_departments_delete_department_question_subtext',
    {
      ru: 'Папка будет удалена навсегда',
      en: 'The folder will be permanently deleted',
    },
  ],
  [
    'admin_departments_delete_department_button',
    {
      ru: 'Удалить',
      en: 'Delete',
    },
  ],
  [
    'admin_departments_delete_department_cancel_button',
    {
      ru: 'Отмена',
      en: 'Cancel',
    },
  ],
  [
    'admin_departments_delete_department_warning_title',
    {
      ru: 'Невозможно удалить папку департамента',
      en: 'Cannot delete department folder',
    },
  ],
  [
    'admin_departments_delete_department_warning_subtext',
    {
      ru: 'Для удаления необходимо переместить сотрудников из этого департамента в другой.',
      en: 'To delete, move employees from this department to another.',
    },
  ],

  [
    'admin_departments_edit_department_edit',
    {
      ru: 'Редактировать',
      en: 'Edit',
    },
  ],
  [
    'admin_departments_edit_department_chief',
    {
      ru: 'Руководитель',
      en: 'Chief',
    },
  ],
  [
    'admin_departments_edit_department_office',
    {
      ru: 'Офис',
      en: 'Office',
    },
  ],
  [
    'admin_departments_department_name',
    {
      ru: 'Название департамента',
      en: 'Department name',
    },
  ],
  [
    'admin_departments_department_parent',
    {
      ru: 'Родительский департамент',
      en: 'Parent department',
    },
  ],
  [
    'admin_departments_head_of_department',
    {
      ru: 'Руководитель департамента',
      en: 'Head of department',
    },
  ],
  [
    'admin_departments_office_label',
    {
      ru: 'Офис',
      en: 'Office',
    },
  ],
  [
    'admin_departments_successfully_updated',
    {
      ru: 'Департамент успешно обновлен',
      en: 'Department successfully updated',
    },
  ],
  [
    'admin_departments_error_update',
    {
      ru: 'Ошибка при обновлении департамента',
      en: 'Error updating department',
    },
  ],
  [
    'admin_departments_successfully_created',
    {
      ru: 'Департамент успешно создан',
      en: 'Department successfully created',
    },
  ],
  [
    'admin_departments_error_create',
    {
      ru: 'Ошибка при создании департамента',
      en: 'Error creating department',
    },
  ],
  [
    'admin_departments_create_department',
    {
      ru: 'Создать департамент',
      en: 'Create department',
    },
  ],
  [
    'admin_departments_edit_department',
    {
      ru: 'Редактировать департамент',
      en: 'Edit department',
    },
  ],
]
